import { Box, Typography } from '@mui/material'
import Step3Image from 'assets/images/artists/step3.webp'
import Step from 'components/pages/artists/SectionSteps/Step'

const Step3Right = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        marginTop: '10vh',
        width: '80%',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: ' #2E004D ',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Get verified and go live!
      </Typography>
      <Typography variant="bodyLato1" sx={{ color: ' #2E004D ' }}>
        Lorem ipsum dolor sit amet consectetur. Cursus magna risus laoreet
        lobortis vel aliquet. Nulla pulvinar cursus eget pharetra tincidunt
        donec arcu commodo at. Auctor ultrices non interdum sem.
      </Typography>
    </Box>
  )
}

const Step3 = () => {
  return (
    <Step
      stepNum={3}
      left={<></>}
      right={<Step3Right />}
      fullHeight
      backgroundImage={Step3Image}
    />
  )
}

export default Step3
